import Vue from 'vue'
import Plugins from './plugins';
import App from './App.vue'
import router from "@/router/index";
import {AuthRedirectGuardMiddleware} from 'gmjs';
import oidc from "@/oidc";

Vue.config.productionTip = false

Vue.use(Plugins);
const authRedirectGuardMiddleware = AuthRedirectGuardMiddleware(oidc);

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  let vue = new Vue();
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      await authRedirectGuardMiddleware.run(to.path, next)
    } catch (e) {
      // Handle exception here
      vue.$error(e)
    }
  } else {
    next();
  }
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.

  NProgress.done();

});

let vue = new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

if (process.env.NODE_ENV === 'production') {
  console.log = function () {
  }
}